export default function titleize(string) {
  const spacedString = string.replace(/[_-]+/g, ' ');
  return spacedString.charAt(0).toUpperCase() + spacedString.slice(1);
}
